<template>
  <div class="page">
    <div class="conteiner">
      <div class="header">
        <div class="head_left">
          <div class="header_icon">
            <img src="../../assets/头像.png" alt="">
            <div class="detail">
              <p class="name">{{name}}</p>
              <!-- <p class="address">地址
								<el-link type="primary">
									<i class="el-icon-edit"></i>修改
								</el-link>
							</p> -->
            </div>
          </div>
          <div class="header_amount">
            <div class="amount">账户余额 ：<span>¥{{balance}}</span></div>
            <el-button type="primary" round @click="dialogvisible = true">充值送券</el-button>
          </div>
        </div>
        <!-- 中间放一根短一点的竖线 -->
        <div class="vertical_line"></div>
        <div class="head_right">
          <div class="right_item">
            <div class="item_top">
              <el-link type="default" href="/orderlist?payStatus=0">待支付(单)<i class="el-icon-arrow-right"></i>
              </el-link>
            </div>
            <div class="item_bottom"><span>{{nopayCount}}</span></div>
          </div>
          <div class="right_item">
            <div class="item_top">
              <el-link type="default" href="/orderlist?orderStatus=0">待确认<i class="el-icon-arrow-right"></i>
              </el-link>
            </div>
            <div class="item_bottom"><span>{{confirmCount}}</span></div>
          </div>
          <div class="right_item">
            <div class="item_top">
              <el-link type="default" href="/orderlist?orderStatus=501">待审核<i class="el-icon-arrow-right"></i>
              </el-link>
            </div>
            <div class="item_bottom"><span>{{auditCount}}</span></div>
          </div>
          <div class="right_item">
            <div class="item_top">
              <el-link type="default" href="/orderlist?orderStatus=8">已完成<i class="el-icon-arrow-right"></i>
              </el-link>
            </div>
            <div class="item_bottom"><span>{{completeCount}}</span></div>
          </div>
        </div>
      </div>
      <div class="content">
        <el-tabs tab-position="left" style="height: 800px;">
          <el-tab-pane label="消费账单">
            <template slot="label">
              <i class="el-icon-price-tag"></i>
              消费账单
            </template>
            <orderbill></orderbill>
          </el-tab-pane>
          <el-tab-pane label="我的优惠卷">
            <template slot="label">
              <i class="el-icon-s-ticket"></i>
              我的优惠卷
            </template>
            <coupon @getmoreEffectCoupon="getmoreEffectCoupon" @dialogclose="dialogclose"></coupon>
          </el-tab-pane>
          <el-tab-pane label="成员管理" v-if="!IsSubStore">
            <template slot="label">
              <i class="el-icon-user"></i>
              成员管理
            </template>
            <member></member>
          </el-tab-pane>
          <el-tab-pane label="地址管理">
            <template slot="label">
              <i class="el-icon-location"></i>
              地址管理
            </template>
            <addressinfo>
            </addressinfo>
          </el-tab-pane>
          <el-tab-pane label="店铺价格">
            <template slot="label">
              <i class="el-icon-price-tag"></i>
              店铺价格
            </template>

            <storeprice>
            </storeprice>
          </el-tab-pane>
          <el-tab-pane label="店铺管理">
            <template slot="label">
              <i class="el-icon-s-shop"></i>
              店铺管理
            </template>
            <accountinfo>
            </accountinfo>
          </el-tab-pane>
          <!-- <el-tab-pane label="账户信息">账户信息</el-tab-pane> -->
        </el-tabs>
      </div>
    </div>

    <recharge :rechargeBack="rechargecallback" :dialogVisible="dialogvisible" @chargeclose="dialogclose">
    </recharge>
  </div>
</template>

<script>
  import orderbill from './orderbill.vue'
  import addressinfo from './addressinfo.vue'
  import accountinfo from './accountinfo.vue'
  import coupon from './coupon.vue'
  import member from './member.vue'
  import store from './store.vue'
  import storeprice from './storeprice.vue'
  import recharge from '../../components/Recharge/recharge.vue'
  export default {
    data() {
      return {
        name: '',
        balance: 0,
        dialogvisible: false,
        nopayCount: 0,
        confirmCount: 0,
        auditCount: 0,
        completeCount: 0,
				IsSubStore:true,
      }
    },
    created() {
      this.getbalance()
      this.GetStoreInfo()
      this.getOrderCount()
    },
    components: {
      orderbill,
      addressinfo,
      accountinfo,
      coupon,
      member,
      store,
      storeprice,
      recharge
    },
    methods: {
      rechargecallback() {
        this.dialogclose();
        this.getEffectCoupon();
      },
      getbalance() {
        this.$api.GetUserBalance().then(res => {
          this.balance = res.data.data.Balance
          //this.name = res.data.data.Contacts
        })
      },
			getmoreEffectCoupon(){
				this.dialogvisible = true
			},
      rechargecallback() {
        this.dialogvisible = false;
        this.getbalance();
      },
      dialogclose() {
        this.dialogvisible = false
        this.getbalance()
      },
      GetStoreInfo() {
        if (cookie.get('storeId') != 'null') {
          this.$api.GetStoreInfo({
            storeId: cookie.get('storeId')
          }).then(res => {
            let {
              data,
              status
            } = res.data;
            if (status == 200) {          
              this.name = data.Contacts;
							this.IsSubStore = data.IsSubStore
            }
          })
        }

      },
      getOrderCount() {
        this.$api.GetOrderCount().then(res => {
          console.log('res.data', res)
          this.nopayCount = res.data.data.nopayCount
          this.confirmCount = res.data.data.confirmCount
          this.auditCount = res.data.data.auditCount
          this.completeCount = res.data.data.completeCount
        })
      }
    }
  }

</script>

<style lang="less">
  .page {
    width: 100%;

    .conteiner {
      width: 75rem;

      margin: 0 auto;

      .header {
        margin: 10px;
        padding: 10px;
        display: flex;
        background-color: #fff;

        .vertical_line {
          width: 1px;
          height: 100px;
          background-color: #ccc;
          margin: 20px 40px 20px 40px;
        }

        .head_left {
					width: 25rem;
          .header_icon {
            display: flex;
            align-items: center;
            margin: 20px;

            img {
              width: 50px;
              height: 50px;
              border-radius: 50%;
              margin-right: 10px;
            }

            .detail {
              display: flex;
              flex-direction: column;
              align-items: flex-start;

              .name {
                font-size: 20px;
                color: #333;
                margin: 0;
                line-height: 34px;
                font-weight: bold;
              }

              .address {
                font-size: 14px;
                color: #999;
                margin: 0;
              }
            }
          }

          .header_amount {
            display: flex;
            align-items: center;
            margin-left: 20px;
            font-size: 14px;
            justify-content: space-between;

            span {
              font-size: 20px;
              font-weight: bold;
            }
          }
        }

        .head_right {
          width: 600px;
          display: flex;

          .right_item {
            width: 150px;
            display: flex;
            flex-direction: column;
            justify-content: center;

            .item_top {
              font-size: 14px;
              color: #999;
              margin: 5px;

            }

            .item_bottom {
              font-size: 20px;
              font-weight: bold;
              margin: 5px 0;

            }
          }
        }
      }

      .content {
        background: #fff;
        margin: 10px;
        // padding: 32px;
				padding: 1.25rem;

        >.el-tabs--left .el-tabs__active-bar.is-left,
        >.el-tabs--left .el-tabs__nav-wrap.is-left::after {
          left: 0;
          right: auto;
        }

        >.el-tabs--left .el-tabs__item.is-left {
          text-align: left;
          /* background-color: #409eff; */
        }

        >.el-tabs--left .el-tabs__item.is-left.is-active {
          color: #409eff;
          background-color: #409eff24 !important;
        }


      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/page/personcenter/personcenter.vue